module.exports = __webpack_public_path__ + "img/monde.8785aaa1.png";